export interface StoreService {
    setSavedState(state: any, localStorageKey: string): void;
    getSavedState(localStorageKey: string): any;
}
